import { maxBy } from "lodash";

/**
 * Ex. : 
 * const obj = { "a": 3, "b": 2, "c": 4 };
 * would return "c"
 * @param obj 
 * @returns 
 */
export function findKeyWithHighestValue(obj) {
    return maxBy(Object.keys(obj), key => obj[key]);
}